module.exports = __webpack_public_path__ + "static/media/FideoChaSiu.9d139e92.jpg";